export let FirstMenuSelection = {
  name: 'selection',
  title: 'Selection',
  shortcut: 'v'
}
